import { render, staticRenderFns } from "./comView.vue?vue&type=template&id=1f9d4532&scoped=true&"
import script from "./comView.vue?vue&type=script&lang=js&"
export * from "./comView.vue?vue&type=script&lang=js&"
import style0 from "./comView.vue?vue&type=style&index=0&id=1f9d4532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d4532",
  null
  
)

export default component.exports